import { useReducer } from "react"
import { Box, Tooltip } from "@mui/material"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import { RoundedButton } from "../../../components/ui/roundButton"
import lockedReducer from "../../../lib/reducer"
import { Input } from "../../../components/ui/input"
import PhoneInputWithCountry from "../../../components/ui/PhoneInputWithCountry"

const CreateAdmin = ({ handleClose, submit }) => {

    const [state, setState] = useReducer(lockedReducer, {
        name: "",
        email: "",
        telephone: "",
    })

    const validateForm = () => {
        const response = []

        if (state.name.trim() === "")
            response.push(<Box>Nome não pode ser vazio.</Box>)
        if (state.email.trim() === "")
            response.push(<Box>E-mail não pode ser vazio.</Box>)
        if (state.telephone.replace(/\D/g, "").length <= 10)
            response.push(<Box>Telefone não pode ser vazio.</Box>)

        if (response.length === 0)
            return ""

        return response
    }

    const validatedForm = validateForm()

    return (
        <DefaultModal
            title={"Adicionar gestor"}
            subtitle="Preencha abaixo para incluir um novo gestor"
            handleClose={handleClose}
            maxWidth="xs"
            action={
                <Box width="100%" display="flex" gap="1rem" sx={{ justifyContent: "space-between" }}>
                    <Box sx={{ width: "100%" }}>
                        <RoundedButton onClick={handleClose} rounded="outlined"  sx={{ width: "100%" }}>
                            Cancelar
                        </RoundedButton>
                    </Box>
                    <Box  sx={{ width: "100%" }}>
                        <Tooltip title={validatedForm}>
                            <span  sx={{ width: "100%" }}>
                                <RoundedButton  sx={{ width: "100%" }} disabled={validatedForm} onClick={()=>submit(state)}>
                                    Salvar
                                </RoundedButton>
                            </span>
                        </Tooltip>
                    </Box>
                </Box>
            }
        >
            <Box display="flex" flexDirection="column" gap="1rem" marginBottom="1rem">
                <div className="space-y-1.5">
                    <label htmlFor="name" className="block text-sm font-semibold text-gray-600">
                        Nome:
                    </label>
                    <Input
                        id="name"
                        placeholder="Nome do colaborador"
                        value={state.name}
                        onChange={({ target }) => setState({ name: target.value })}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-300 outline-none focus:border-gray-300 bg-white"
                    />
                </div>
                <div className="space-y-1.5">
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-600">
                        E-mail:
                    </label>
                    <Input
                        id="email"
                        placeholder="E-mail"
                        value={state.email}
                        onChange={({ target }) => setState({ email: target.value })}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-300 outline-none focus:border-gray-300 bg-white"
                    />
                </div>
                <div className="space-y-1.5">
                    <label htmlFor="phone" className="block text-sm font-semibold text-gray-600">
                        Telephone:
                    </label>
                    <PhoneInputWithCountry
                        id="phone"
                        value={state.telephone}
                        background="white"
                        onChange={(v) => setState({ telephone: v })} />
                </div>
            </Box>
        </DefaultModal>
    )
}

export default CreateAdmin
